import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import logo from "../Assets/Frontend_Assets/logo.png";
import instagram_icon from "../Assets/Frontend_Assets/ins.png";
import tiktok_icon from "../Assets/Frontend_Assets/tk.png";
import facebook_icon from "../Assets/Frontend_Assets/fb.png";

const Footer = () => {
  return (
    <footer className="lux-footer">
      {/* GLOWS */}
      <span className="lux-footer-glow lux-footer-glow-left"></span>
      <span className="lux-footer-glow lux-footer-glow-right"></span>

      <div className="lux-footer-container">
        {/* BRAND */}
        <div className="lux-footer-brand">
          <img src={logo} alt="Prime Cosmo Logo" />
          <h2>Prime Cosmo</h2>
          <p>Premium Hair, Beard & Skin Care Products</p>
        </div>

        {/* LINKS */}
        <ul className="lux-footer-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/hairoil">Hair Oils</Link>
          </li>
          <li>
            <Link to="/beardoil">Beard Oils</Link>
          </li>
          <li>
            <Link to="/soap">Soaps</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>

        {/* SOCIAL ICONS */}
        <div className="lux-footer-social">
          <a
            href="https://www.instagram.com/priimecosmo/"
            target="_blank"
            rel="noopener noreferrer"
            className="lux-social-box"
            aria-label="Instagram"
          >
            <img src={instagram_icon} alt="Instagram" />
          </a>

          <a
            href="https://www.tiktok.com/@primecosmoo?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            className="lux-social-box"
            aria-label="TikTok"
          >
            <img src={tiktok_icon} alt="TikTok" />
          </a>

          <a
            href="https://www.facebook.com/profile.php?id=61586515701562&_rdc=1&_rdr#"
            target="_blank"
            rel="noopener noreferrer"
            className="lux-social-box"
            aria-label="Facebook"
          >
            <img src={facebook_icon} alt="Facebook" />
          </a>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="lux-footer-bottom">
        <hr />
        <p>© 2025 Prime Cosmo — All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
